<p-card
	[header]="'presentation.app.page.settings.coach.general.header' | translate"
	class="h-full"
	styleClass="h-full"
>
	<div [formGroup]="informationForm" class="flex flex-col space-y-3">
		<div class="flex flex-col space-y-1 items-stretch">
			<label
				[title]="
					'presentation.app.page.settings.coach.general.firstName.label' | translate
				"
				class="truncate"
			>
				{{
					'presentation.app.page.settings.coach.general.firstName.label' | translate
				}}
			</label>
			<input
				[placeholder]="
					'presentation.app.page.settings.coach.general.firstName.placeHolder'
						| translate
				"
				class="details-item self-stretch"
				formControlName="firstName"
				pInputText
			/>
		</div>
		<div class="flex flex-col space-y-1 items-stretch">
			<label
				[title]="
					'presentation.app.page.settings.coach.general.lastName.label' | translate
				"
				class="truncate"
			>
				{{
					'presentation.app.page.settings.coach.general.lastName.label' | translate
				}}
			</label>
			<input
				[placeholder]="
					'presentation.app.page.settings.coach.general.lastName.placeHolder'
						| translate
				"
				class="details-item self-stretch"
				formControlName="lastName"
				pInputText
			/>
		</div>
		<div class="flex flex-col space-y-1 items-stretch">
			<label
				[title]="
					'presentation.app.page.settings.coach.general.phoneNumber.label'
						| translate
				"
				class="truncate"
			>
				{{
					'presentation.app.page.settings.coach.general.phoneNumber.label'
						| translate
				}}
			</label>
			<input
				[placeholder]="
					'presentation.app.page.settings.coach.general.phoneNumber.placeHolder'
						| translate
				"
				class="details-item self-stretch"
				formControlName="phoneNumber"
				pInputText
			/>
		</div>
		<div class="flex items-start space-x-3">
			<div class="flex flex-col flex-1 space-y-1 items-stretch overflow-hidden">
				<label
					[title]="
						'presentation.app.page.settings.coach.general.birthDate.label' | translate
					"
					class="truncate"
				>
					{{
						'presentation.app.page.settings.coach.general.birthDate.label' | translate
					}}
				</label>
				<p-calendar
					[inputStyle]="{ width: '100%' }"
					[locale]="calendarLocale$ | async"
					[monthNavigator]="true"
					[placeholder]="
						'presentation.app.page.settings.coach.general.birthDate.placeHolder'
							| translate
					"
					[readonlyInput]="false"
					[style]="{ width: '100%' }"
					[yearNavigator]="true"
					[yearRange]="birthDateRange"
					class="details-item self-stretch"
					appendTo="body"
					dateFormat="dd/mm/yy"
					formControlName="birthDate"
				></p-calendar>
			</div>
			<div class="flex flex-col flex-1 space-y-1 items-stretch overflow-hidden">
				<label
					[title]="
						'presentation.app.page.settings.coach.general.birthAddress.label'
							| translate
					"
					class="truncate"
				>
					{{
						'presentation.app.page.settings.coach.general.birthAddress.label'
							| translate
					}}
				</label>
				<input
					[placeholder]="
						'presentation.app.page.settings.coach.general.birthAddress.placeHolder'
							| translate
					"
					class="details-item self-stretch"
					formControlName="birthAddress"
					pInputText
				/>
			</div>
		</div>
		<div class="flex items-start space-x-3">
			<div class="flex flex-col flex-1 space-y-1 items-stretch overflow-hidden">
				<label
					[title]="
						'presentation.app.page.settings.coach.general.currentAddress.label'
							| translate
					"
					class="truncate"
				>
					{{
						'presentation.app.page.settings.coach.general.currentAddress.label'
							| translate
					}}
				</label>
				<input
					[placeholder]="
						'presentation.app.page.settings.coach.general.currentAddress.placeHolder'
							| translate
					"
					class="details-item self-stretch"
					formControlName="currentAddress"
					pInputText
				/>
			</div>
			<div class="flex flex-col flex-1 space-y-1 items-stretch overflow-hidden">
				<label
					[title]="
						'presentation.app.page.settings.coach.general.timeZone.label' | translate
					"
					class="truncate"
				>
					{{
						'presentation.app.page.settings.coach.general.timeZone.label' | translate
					}}
				</label>
				<p-dropdown
					[filter]="true"
					[itemSize]="30"
					[options]="timeZones"
					[placeholder]="
						'presentation.app.page.settings.coach.general.timeZone.placeHolder'
							| translate
					"
					[virtualScroll]="true"
					appendTo="body"
					formControlName="timeZone"
					styleClass="w-full min-w-0"
				></p-dropdown>
			</div>
		</div>
		<div class="flex flex-col space-y-1 items-stretch">
			<label
				[title]="
					'presentation.app.page.settings.coach.general.linkedin.label' | translate
				"
				class="truncate"
			>
				{{
					'presentation.app.page.settings.coach.general.linkedin.label' | translate
				}}
			</label>
			<input
				[placeholder]="
					'presentation.app.page.settings.coach.general.linkedin.placeHolder'
						| translate
				"
				class="details-item self-stretch"
				formControlName="linkedInUrl"
				pInputText
			/>
		</div>
	</div>
</p-card>
